import api from './api';

// 获得阅读量排名前十的新闻
export function topTen(params) {
  return api.post('/news/getlastnewslist', params, true, false).then(res => res);
}

// 获得新闻模块新闻列表
export function newsListInfo(params) {
  return api.post('/news/getlistbytype', params, true, false).then(res => res);
}

// 获取指定页码和个数的新闻
export function getNewsListByPageNoSize(params) {
  return api.post('/news/getlistbycount', params, true, false).then(res => res);
}

// 回调点赞数量
export function returnAdmired(params) {
  return api.post('/news/setsupportnum', params, true, false).then(res => res);
}

// 回调阅读数量
export function returnReadNo(params) {
  return api.post('/news/setreadnum', params, true, false).then(res => res);
}

// 回调转发数量
export function returnTransmitNo(params) {
  return api.post('/news/setforwardnum', params, true, false).then(res => res);
}

// 通过新闻ID获得新闻的内容
export function getNewsById(params) {
  return api.post('/news/info', params, true, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/frontApi/frontNews.js